import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import SectionHeading from "@/components/base/SectionHeading";

export default function TopicGrid() {
  return (
    <section id="topics" className="bg-background-50 py-14 md:py-20 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <SectionHeading
          kicker="按兴趣逛"
          title="话题分类"
          desc="六个常驻栏目，覆盖从全网热议到生活趣闻的不同方向。挑一个你感兴趣的分类，蹲住就完事了。"
        />

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {topics.map((topic) => (
            <Link
              key={topic.id}
              to={`/topic/${topic.id}`}
              className="group relative flex flex-col h-full rounded-lg bg-background-50 border border-background-200/80 p-5 hover:border-accent-300 transition-colors cursor-pointer"
            >
              <div className="flex items-start justify-between">
                <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                  <i className={`${topic.icon} text-2xl`}></i>
                </span>
                <span className="text-xs font-label text-foreground-500 bg-background-100 px-2.5 py-1 rounded-full">
                  {topic.count} 篇
                </span>
              </div>
              <h3 className="mt-4 font-heading font-bold text-lg text-foreground-900">
                {topic.name}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">
                {topic.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-label text-accent-700">
                进入分类
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}